export enum DistributionUsage {
  CODE = 'CODE',
  INFORMATION = 'INFORMATION'
}
